import React, { useState } from 'react';
import MachineStatusTab from '../LiveFloorViewer/MachineStatusTab';
import { Tab } from 'semantic-ui-react';
import OperationalTab from '../LiveFloorViewer/OperationalTab';
import SiteControllerTab from '../LiveFloorViewer/SiteControllerTab';
import SiteDetailsTab from '../LiveFloorViewer/SiteDetailsTab';

const LiveFloorView = (props) => {

  const panes = [
    {
      key: "Site Details",
      menuItem: "Site Details",
      render: () => <Tab.Pane><SiteDetailsTab /></Tab.Pane>
    },
    {
      key: "Machine Status",
      menuItem: "Machine Status",
      render: () => <Tab.Pane><MachineStatusTab /></Tab.Pane>
    },
    /*
    {
      key: "Machine Operational Filters",
      menuItem: "Machine Operational Filters",
      render: () => <Tab.Pane><OperationalTab /></Tab.Pane>
    },
    */
    /*
    {
      key: "Site Controller Status",
      menuItem: "Site Controller Status",
      pane: <Tab.Pane><SiteControllerTab /></Tab.Pane>
    },
    */
  ];

    return (
      <div className="flex-stretch gs-flex-container-vertical height-100">
        <Tab renderActiveOnly={true} panes={panes} className="flex-stretch gs-flex-container-vertical mt-1 height-100" />
      </div>
    )
};

export default LiveFloorView;
